export interface PunchoutSessionRenewalOptions {
  renewalThresholdSeconds: number;
  renewalIntervalSeconds: number;
}

export const defaultPunchoutSessionRenewalOptions: PunchoutSessionRenewalOptions = {
  renewalThresholdSeconds: 300, // Start checking 5 minutes before expiry
  renewalIntervalSeconds: 30, // Retry every 30 seconds
};
